import { useState } from "react";

import { Select } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { BankSpecificStatus } from "types";

const STATUSES: BankSpecificStatus[] = [
  "IN_PREPARATION",
  "IN_PROGRESS",
  "ADDITIONAL_INFO_REQUIRED",
  "APPROVED",
  "SIGNING",
  "CONTRACT_VERIFICATION",
  "SIGNED_COMPLETE",
  "REJECTED",
  "SIGNING_SUSPENDED",
];

const STATUS_COLOR = "rgba(221, 153, 45, 1)";

interface StatusBadgeProps {
  status?: BankSpecificStatus;
  statuses?: BankSpecificStatus[];
  onChange?: (status: BankSpecificStatus) => void;
  disabled?: boolean;
  loading?: boolean;
}

export const StatusBadge = ({ status, statuses, onChange, disabled, loading }: StatusBadgeProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const availableStatuses = statuses ?? STATUSES;

  const statusOptions = [
    ...(status && !availableStatuses.includes(status)
      ? [{ value: status, label: t(`bankSelection.status.${status}`), disabled: true }]
      : []),
    ...availableStatuses.map((s) => ({ value: s, label: t(`bankSelection.status.${s}`) })),
  ];

  return (
    <Select
      size="xs"
      value={status || null}
      onChange={(value) => value && onChange?.(value as BankSpecificStatus)}
      data={statusOptions}
      placeholder={t("bankSelection.status.label")}
      disabled={disabled || loading}
      allowDeselect={false}
      withCheckIcon={false}
      rightSection={
        isOpen ? (
          <IconChevronUp size={14} color={STATUS_COLOR} />
        ) : (
          <IconChevronDown size={14} color={STATUS_COLOR} />
        )
      }
      onDropdownOpen={() => setIsOpen(true)}
      onDropdownClose={() => setIsOpen(false)}
      styles={{
        input: {
          width: 200,
          height: 32,
          minHeight: 32,
          border: `1px solid ${STATUS_COLOR}`,
          color: STATUS_COLOR,
          fontWeight: 500,
          fontSize: 13,
          borderRadius: 6,
          backgroundColor: "transparent",
          paddingRight: 24,
          paddingLeft: 10,
        },
        dropdown: {
          minWidth: 220,
        },
      }}
    />
  );
};
